import { Base2Presenter } from "core/presenter";
import { RuntimeRepository } from "core/repository";

export default class FabPresenter extends Base2Presenter {
  initialState() {
    return {
      supportVisible: false
    };
  }

  async onStart() {
    this.subscribeTo(RuntimeRepository.props.supportVisible, supportVisible => {
      this.enqueue({ supportVisible });
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/support/fab/presenter.js